{
  "actionbar.actions": "Toimingud",
  "actionbar.actionsAvailable": "Toimingud saadaval.",
  "actionbar.clearSelection": "Puhasta valik",
  "actionbar.selected": "{count, plural, =0 {Pole valitud} other {# valitud}}",
  "actionbar.selectedAll": "Kõik valitud",
  "actionbutton.pending": "ootel",
  "breadcrumbs.more": "Veel üksusi",
  "button.pending": "ootel",
  "calendar.invalidSelection": "Valitud {selectedCount, plural, one {kuupäev} other {kuupäevad}} pole saadaval.",
  "combobox.loading": "Laadimine...",
  "combobox.loadingMore": "Laadi rohkem...",
  "combobox.noResults": "Tulemusi pole",
  "contextualhelp.help": "Spikker",
  "contextualhelp.info": "Teave",
  "datepicker.endTime": "Lõpuaeg",
  "datepicker.startTime": "Algusaeg",
  "datepicker.time": "Aeg",
  "dialog.alert": "Teade",
  "dialog.dismiss": "Lõpeta",
  "dropzone.replaceMessage": "Kukuta fail asendamiseks",
  "inlinealert.informative": "Teave",
  "inlinealert.negative": "Viga",
  "inlinealert.notice": "Hoiatus",
  "inlinealert.positive": "Valmis",
  "label.(optional)": "(valikuline)",
  "label.(required)": "(nõutav)",
  "listview.loading": "Laadimine...",
  "listview.loadingMore": "Laadi rohkem...",
  "menu.loading": "Laadimine...",
  "menu.loadingMore": "Laadi rohkem...",
  "menu.moreActions": "Veel toiminguid",
  "menu.noResults": "Tulemusi pole",
  "menu.unavailable": "Pole kättesaadav, üksikasjade vaatamiseks laiendage",
  "notificationbadge.indicatorOnly": "Uus tegevus",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Laadimine...",
  "picker.loadingMore": "Laadi rohkem...",
  "picker.placeholder": "Valige…",
  "picker.selectedCount": "{count, plural, =0 {üksuseid pole valitud} one {# üksus valitud} other {# üksust valitud}}",
  "sidepanel.collapse": "Ahenda külgpaneel",
  "sidepanel.expand": "Laienda külgpaneel",
  "slider.maximum": "Maksimaalne",
  "slider.minimum": "Minimaalne",
  "table.cancel": "Tühista",
  "table.drag": "Lohista",
  "table.editCell": "Muuda lahtrit",
  "table.loading": "Laadimine...",
  "table.loadingMore": "Laadi rohkem...",
  "table.resizeColumn": "Muuda veeru suurust",
  "table.save": "Salvesta",
  "table.sortAscending": "Sordi kasvavalt",
  "table.sortDescending": "Sordi kahanevalt",
  "tag.actions": "Toimingud",
  "tag.hideButtonLabel": "Kuva vähem",
  "tag.noTags": "Puudub",
  "tag.showAllButtonLabel": "Kuva kõik ({tagCount, number})",
  "toast.clearAll": "Tühjenda kõik",
  "toast.collapse": "Ahenda",
  "toast.showAll": "Kuva kõik",
  "treeview.loadingMore": "Laadi rohkem..."
}
